
<v-form ref="form" class="w-100" v-if="item">
    <v-container fluid class="pa-2">
        <v-row dense>
            <v-col class="pr-2">
                <f-title :title="$t('inb.detail.head.title')" />
                <v-row dense class="mb-5">
                    <v-col class="pa-0">
                        <c-inb-context
                            :item     = "item"
                            :readonly = "readonly"
                            @morph    = "onMorph"
                            @changed  = "onContext"
                            ref       = "siteselect"
                        />
                    </v-col>
                </v-row>

                <f-title
                    title="Wartungsnachweis"
                    class="mt-0"
                />

                <v-text-field
                    v-model="item.subject"
                    label="Betreff"
                    class="mt-4"
                    :readonly      = "readonly"
                    :disabled      = "readonly"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />

                <f-date-picker
                    v-model="item.executiondate"
                    label ="inb.maintenance.exedate"
                    :rules="[requiredRule]"
                    :readonly = "readonly"
                    @change   = "onContext"
                />

                <v-text-field
                    label          = "Vertragsnummer"
                    v-model        = "item.contractno"
                    :readonly      = "readonly"
                    :disabled      = "readonly"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />

                <v-text-field
                    label          = "Auftragsnummer"
                    v-model        = "item.orderno"
                    :readonly      = "readonly"
                    :disabled      = "readonly"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />

                <v-text-field
                    label="Servicetechniker"
                    v-model="item.technician"
                    :readonly      = "readonly"
                    :disabled      = "readonly"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />
            </v-col>

            <v-col class="pl-2">
                <f-title title="Ausgeführte Arbeiten" class="mt-0" />
                <v-select
                    :items            = "item.units"
                    v-model           = "selected"
                    label             = "Anlage"
                    item-value        = "id"
                    item-text         = "unit.fabricNo"
                    :return-object    = true
                    :readonly         = "readonly"
                    :hide-details     = "true"
                >
                    <template v-slot:selection="{ item }">
                        <div class="item-selection v-list-item__title">
                            {{ item.unit.fabricNo }}
                        </div>
                    </template>
                </v-select>

                <v-textarea
                    v-if="selected"
                    label="Beschreibung"
                    v-model="selected.description"
                    no-resize
                    required
                    rows="15"
                    class="mt-3"
                    :readonly      = "readonly"
                    :disabled      = "readonly"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />

                <v-textarea
                    v-if="selected"
                    label="Ergebnis"
                    v-model="selected.result"
                    no-resize
                    required
                    rows="12"
                    class="mt-3"
                    :readonly      = "readonly"
                    :disabled      = "readonly"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                />
            </v-col>
        </v-row>
    </v-container>
</v-form >
